module.exports = __webpack_public_path__ + "img/logo.a676ca91.png";